 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {useMemo} from 'react'
import useSpotlightResults from '~/hooks/useSpotlightResults'


import useSpotlightVisibleReflections from './useSpotlightVisibleReflections'

const useSpotlightReflectionGroup = (
  meeting,
  reflectionGroup,
  isBehindSpotlight,
  reflectionIdsToHide
) => {
  const {spotlightGroup, spotlightSearchQuery} = meeting
  const spotlightGroupId = _optionalChain([spotlightGroup, 'optionalAccess', _ => _.id])
  const {reflections, id: reflectionGroupId} = reflectionGroup
  const isSpotlightSrcGroup = spotlightGroupId === reflectionGroupId
  const isSpotlightOpen = !!spotlightGroupId
  const spotlightResultGroups = useSpotlightResults(meeting)
  const visibleReflections = useSpotlightVisibleReflections(
    reflections,
    spotlightSearchQuery,
    reflectionIdsToHide
  )
  const isRemoteSpotlightSrc = useMemo(
    () => !!visibleReflections.find(({remoteDrag}) => _optionalChain([remoteDrag, 'optionalAccess', _2 => _2.isSpotlight])),
    [visibleReflections]
  )
  const disableDrop = useMemo(() => {
    const isViewerDraggingResult = !!_optionalChain([spotlightResultGroups, 'optionalAccess', _3 => _3.find, 'call', _4 => _4(({reflections}) =>
      _optionalChain([reflections, 'optionalAccess', _5 => _5.find, 'call', _6 => _6(({isViewerDragging}) => isViewerDragging)])
    )])
    return isSpotlightOpen
      ? (isViewerDraggingResult && !isSpotlightSrcGroup) || isBehindSpotlight // prevent grouping results into results
      : isRemoteSpotlightSrc // prevent dropping onto animating remote source
  }, [spotlightResultGroups, isSpotlightSrcGroup, isBehindSpotlight, isRemoteSpotlightSrc])
  return {isRemoteSpotlightSrc, disableDrop, visibleReflections}
}

export default useSpotlightReflectionGroup
